import _extends from "@babel/runtime/helpers/extends";
import { Box, FormField, Text, ToggleSwitch } from '@wix/design-system';
import React from 'react';
import { RuleListStatus } from '../../../types';
import { dataHooks } from '../../../utils/datahooks';
import { RuleFooter, RuleLayout } from '../../rule-layout';
import { ToggleFixerCompletedState } from './toggle-rule-completed-state';
import { useToggleFixer } from './use-toggle-fixer';
export const ToggleRuleFixer = _ref => {
  let {
    ruleResult
  } = _ref;
  const {
    checkedValue,
    toggleLabel,
    ruleFooterProps,
    description,
    onChange,
    tips
  } = useToggleFixer(ruleResult);
  const design = ruleResult.fixerProps.design;
  return ruleResult.status === RuleListStatus.passed ? /*#__PURE__*/React.createElement(ToggleFixerCompletedState, {
    description: description,
    ruleResult: ruleResult
  }) : /*#__PURE__*/React.createElement(RuleLayout, {
    description: description,
    design: design == null ? void 0 : design.ruleLayout
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: (design == null ? void 0 : design.formGap) ?? 'SP1'
  }, /*#__PURE__*/React.createElement(FormField, {
    label: /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      secondary: true
    }, toggleLabel),
    labelPlacement: "right",
    stretchContent: false
  }, /*#__PURE__*/React.createElement(ToggleSwitch, {
    checked: checkedValue,
    dataHook: dataHooks.toggleFieldToggleFixer(ruleResult.dataHook),
    disabled: ruleFooterProps.submitButtonProps.showLoader,
    size: "small",
    onChange: () => onChange(!checkedValue)
  })), tips), /*#__PURE__*/React.createElement(RuleFooter, _extends({}, ruleFooterProps, {
    design: design == null ? void 0 : design.ruleFooter
  })));
};
//# sourceMappingURL=toggle-rule-fixer.js.map